import { createListViewComponent } from 'factories/ListView'
import entityNames from 'options/entityNames'
import Filter from 'containers/Reports/InventoryOnHandExceptionReport/Filter'

export default createListViewComponent({
  entityName: entityNames.inventoryOnHandExceptionReport,
  filterTemplateType: 'InventoryOnhandExceptionReport',
  initialFilterDto: (self) => ({ dateRange: { dateRangeType: 'YearToDate' } }),
  allowCreate: (self) => false,
  allowSelection: (self) => false,
})(Filter)
